import { MaterialReactTable } from "material-react-table";
import React from "react";
import { CONTACT_USERS_COLUMN } from "./contactData";

export default function ContactTable({ isFetching, data }) {
  return (
    <>
      <MaterialReactTable
        state={{ showSkeletons: isFetching }}
        columns={CONTACT_USERS_COLUMN}
        data={data ?? []}
        initialState={{ density: "compact", pagination: { pageSize: 20 } }}
        enableDensityToggle={false}
      />
    </>
  );
}
